import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpMethodsEnum } from 'app/static/enums';
import { END_POINTS } from 'app/static/api';
import { HttpOptions } from 'app/services/http/models/http-options';
import { HttpParams } from '@angular/common/http';
import { HttpService } from 'app/services/http/http.service';
import { GetCardInfoForm, PaymentForm } from '../../pages/charge/models/forms';
import { GetCardInfoResponse, SendPaymentDataResponse } from '../../pages/charge/models/api-response';

@Injectable({
  providedIn: 'root'
})
export class ChargeHttpService {

  constructor(
    private readonly httpService: HttpService
  ) { }

  getCardInfo(form: GetCardInfoForm): Observable<GetCardInfoResponse> {
    const method = HttpMethodsEnum.Post;
    const url = END_POINTS.cardInfo;
    const options: HttpOptions = {
      body: new HttpParams()
        .append('cardno', form.cardno)
    }

    return this.httpService.request(method, url, options);
  }


  sendPaymentData(form: PaymentForm): Observable<SendPaymentDataResponse> {
    const method = HttpMethodsEnum.Post;
    const url = END_POINTS.paymentData;
    const options: HttpOptions = {
      body: new HttpParams()
        .append('cardno', form.cardno)
        .append('amount', form.amount)
    }

    return this.httpService.request(method, url, options);
  }


}
